import React from "react";
import { FormControl, FormGroup, FormLabel } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import SubmitButton from "components/SubmitButton";

class AbsenceAnswerModal extends React.Component {
	state = {
		answer: this.props.absence.answer_comments || "",
		isLoading: false,
	};

	handleSubmit = async (isApproved) => {
		this.setState({ isLoading: true });
		const success = await this.props.onSubmit(isApproved, this.state.answer);

		if (success) {
			this.props.handleClose();
			return;
		}

		this.setState({ isLoading: false });
	};

	render() {
		const { t, handleClose } = this.props;
		const { answer, isLoading } = this.state;

		return (
			<div className="absence-answer-modal">
				<div className="modal-body">
					<FormGroup controlId="answer_comments" className="form-group">
						<FormLabel>{t("absences.form.comments")}</FormLabel>
						<FormControl
							as="textarea"
							rows={3}
							value={answer}
							onChange={(event) => this.setState({ answer: event.target.value })}
							placeholder={t("absences.form.approveReasonPlaceholder")}
						/>
					</FormGroup>
				</div>

				<div className="modal-footer absence-answer-modal-footer">
					<button
						type="button"
						className="btn btn-outline-secondary"
						disabled={isLoading}
						onClick={handleClose}
					>
						{t("common.cancel")}
					</button>
					<button
						type="button"
						className="btn btn-danger"
						disabled={isLoading}
						onClick={() => this.handleSubmit(false)}
					>
						{t("absences.deny")}
					</button>
					<SubmitButton
						isLoading={isLoading}
						text={t("absences.approve")}
						loadingText={t("common.saving")}
						onClick={() => this.handleSubmit(true)}
					/>
				</div>
			</div>
		);
	}
}

export default withTranslation()(AbsenceAnswerModal);
